import { Header, Footer } from '@/components/layout'
import { Pricing } from '@/components/sections'
import { SEO } from '@/components/seo'

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Pricing"
        description="Simple, transparent pricing for JumpstoneAuth. Start free with up to 1,000 monthly active users. No credit card required."
        canonical="/pricing"
      />
      <Header />
      <main className="pt-16">
        <Pricing />
      </main>
      <Footer />
    </div>
  )
}

